import { i18n } from '@lt/localization';
import React from 'react';
import styled, { css } from 'styled-components';
import { pluralizeYears } from 'src/utils/pluralizeUtils';
import { isChild } from '../../utils';
import ShowSavedTouristButton from '../ShowSavedTouristButton';
import TouristDocumentType from '../../DocumentType';
import type { DocType } from '../../types';

type TouristsFormHeaderProps = {
  age: number;
  isMobile: boolean;
  country: string;
  docType: DocType;
  nationalityId: number;
  handleDocTypeChange: (docType: string) => void;
  onTouristSelect: (touristsData: any) => void;
  showCustomerInfo: boolean;
};

const TouristsFormHeader = (props: TouristsFormHeaderProps) => {
  const {
    age,
    isMobile,
    country,
    docType,
    nationalityId,
    handleDocTypeChange,
    onTouristSelect,
    showCustomerInfo,
  } = props;
  return (
    <HeaderContainer $isMobile={isMobile}>
      <RoomInfo $isMobile={isMobile}>
        1 {i18n.t('checkout.touristForm.room')}
      </RoomInfo>
      <div>
        {isChild(age)
          ? `${i18n.t('checkout.touristForm.child')}, ${age} ${pluralizeYears(
              age,
            )}`
          : i18n.t('checkout.touristForm.adult')}
        {!isMobile && <DividerDot />}
      </div>
      <TouristDocumentType
        age={age}
        country={country}
        value={docType}
        touristCitizenship={nationalityId}
        onChange={handleDocTypeChange}
      />
      {showCustomerInfo && (
        <CustomerInfo $isMobile={isMobile}>
          {i18n.t('checkout.touristForm.customerInfo')}
        </CustomerInfo>
      )}
      {isMobile && (
        <ShowSavedTouristButton
          docType={docType}
          onClickOption={onTouristSelect}
        />
      )}
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div<{ $isMobile: boolean }>`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #4d4d4d;

  ${(props) =>
    props.$isMobile &&
    css`
      flex-wrap: wrap;
    `}
`;

const CustomerInfo = styled.div<{ $isMobile: boolean }>`
  color: #17181a;
  font-size: 14px;
  line-height: 16px;

  ${(props) =>
    props.$isMobile
      ? css`
          margin-top: 2px;
        `
      : css`
          margin-left: 8px;
        `}
`;

const RoomInfo = styled.div<{ $isMobile: boolean }>`
  margin-right: 10px;
  padding: 2px 9px 4px 8px;
  display: inline-flex;
  font-size: 12px;
  font-weight: bold;
  color: #17181a;
  border: solid 1px #f8e71c;
  border-radius: 10px;

  ${(props) =>
    props.$isMobile &&
    css`
      white-space: nowrap;
    `}
`;

const DividerDot = styled.span`
  &::after {
    padding: 0 0.3em;
    white-space: pre;
    content: '•';
  }
`;
export default TouristsFormHeader;
